import { ReactElement } from "react";

interface UserResponseConfig {
    userIcon?: ReactElement;
}

export interface AlmeUserResponseConfig {
    userResponse: UserResponseConfig;
}

/**
 * This is the baseline response config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeUserResponseConfig = {
    userResponse: {
    },
};

export default defaultConfig;